/**
 * Owns the (single) inline dialog of a provider view. `prompt()` / `confirm()`
 * put the dialog in plugin state — the view renders `ProviderDialog` from it —
 * and resolve once the dialog calls `submit()` or `cancel()`. Opening a new
 * dialog cancels the pending one.
 */
export default class ProviderDialogController {
    #store;
    #settlePending = null;
    #revision = 0;
    /** Remount the input when replacing a prompt in the same render batch. */
    get revision() {
        return this.#revision;
    }
    constructor(store) {
        this.#store = store;
    }
    /** Resolves with the entered string, or `null` when cancelled. */
    prompt(options) {
        return new Promise((resolve) => {
            this.#open({ kind: 'prompt', ...options }, (confirmed, value) => resolve(confirmed ? (value ?? '') : null));
        });
    }
    /** Resolves with `true` when confirmed, `false` when cancelled. */
    confirm(options) {
        return new Promise((resolve) => {
            this.#open({ kind: 'confirm', ...options }, resolve);
        });
    }
    /** Called by the dialog; `value` is the prompt's input. */
    submit = (value) => this.#settle(true, value);
    cancel = () => this.#settle(false);
    #open(dialog, settle) {
        this.cancel();
        this.#revision += 1;
        this.#settlePending = settle;
        this.#store.setPluginState({ dialog });
    }
    #settle(confirmed, value) {
        const settle = this.#settlePending;
        if (!settle)
            return;
        this.#settlePending = null;
        this.#store.setPluginState({ dialog: undefined });
        settle(confirmed, value);
    }
}
